export const USER_ROLE = {
  ROLE_OWNER: 'owner',
  ROLE_MANAGER: 'manager',
  ROLE_HR: 'hr',
} as const;

export type USER_ROLE_TYPE = (typeof USER_ROLE)[keyof typeof USER_ROLE];

export const USER_ROLE_NAME: Record<USER_ROLE_TYPE, string> = {
  [USER_ROLE.ROLE_HR]: 'hr',
  [USER_ROLE.ROLE_MANAGER]: '用人经理',
  [USER_ROLE.ROLE_OWNER]: '所有者',
} as const;

// 以上都无用了

export enum WorkStatusEnum {
  Running = 'running',
  Stopped = 'stopped',
}
